module.exports = __webpack_public_path__ + "img/equipos-moviles-clasica.e8e3291d.jpg";